import React, {useEffect, useState,} from "react";
import {Select as AntSelect} from "antd";
import {SelectProps} from "antd/lib/select";
import request from "../../utils/request";


interface MySelectProps extends SelectProps<any> {
    url: string
    textField?: string
    valueField?: string
    getData?: (data: any) => any
    setDefault?: (data: any) => any
}

function Select(props: MySelectProps) {

    const [data, setData] = useState([])
    const {url, textField = 'text', valueField = 'id', getData, onChange, setDefault, ...otherProps} = props

    useEffect(() => {
        request.get(url).then(response => {
            let data = response.data
            if (getData) {
                data = getData(data)
            }
            setData(data)
            if (setDefault && onChange) {
                const item = setDefault(data)
                item && onChange(item, {} as any)
            }
        })
    }, [url])

    return (
        <AntSelect showSearch optionFilterProp={'children'} onChange={onChange} {...otherProps}>
            {data.map(item => (
                <AntSelect.Option key={item[valueField]} value={item[valueField]}>
                    {item[textField]}
                </AntSelect.Option>
            ))}
        </AntSelect>
    )
}

export default Select